import { filter, lastValueFrom, Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/_services/global.service';
import { SignupService } from 'src/app/_services/signup.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { WhiteLabelList } from 'src/app/_data/white-label-list';

@Component({
    selector: 'app-new-signup-personal-info',
    templateUrl: './new-signup-personal-info.component.html',
    styleUrls: ['./new-signup-personal-info.component.scss'],
})
export class NewSignupPersonalComponent implements  OnInit, AfterViewInit {
  editform: FormGroup
  localActiveItem = this._signup.personalInfo
  displayTerms = false
  displayWhat = 'terms-and-conditions'
  displayWhos = ''

  emailValidatorString = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  passwordValidatorString = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/
  displayPasswordError = false

  _globals = GlobalService


    @ViewChild('InputPassword')
    InputPassword!: ElementRef;
     companyNameExist: boolean = false;

    hasSelectedPlan = false;
    selectedPlanUrl: string | null = null;

  constructor(
    public _signup: SignupService,
    private _fb: FormBuilder,
    private _connMessageService: ConnMessageService,
    private _spinner: NgxSpinnerService,
    private _router: Router,
      private eRef: ElementRef,
      private route: ActivatedRoute,
      private renderer: Renderer2,
      @Inject(DOCUMENT) document: Document
  ) { }
    ngAfterViewInit(): void {
        this.setAttribute('email', 'autocomplete', 'new-password')
    }

    private setAttribute(feild, attribute, value): void {
        document.getElementsByName(feild).forEach(x => {
            x.setAttribute(attribute, value)
        })
            // document.querySelectorAll('input[type=password]')[0]?.setAttribute("autocomplete","new-password");

    }

  get f() {
    return this.editform.controls;
  }

  ngOnInit(): void {
    this._signup.accountVerified = false
    this.initForm()
    localStorage.removeItem('user')

    this._signup.userAccountPendingForPayment = false
  }
    syncUserToWebsite(){

     let data =
      {
        "first_name":this._signup.personalInfo.firstName,
        "last_name": this._signup.personalInfo.lastName,
        "email": this._signup.personalInfo.email,
        "password": this._signup.personalInfo.password,
        "business_name": this._signup.businessInfo.businessName,
        "business_id": this._signup.businessInfo.businessId.toString(),
        "verification_status": 1,     //hard
       "saasy_user_id": this._signup.businessInfo.userID.toString(),
       "phone_number": this._signup.personalInfo.phone.toString(),
       "terms_and_conditions":"1",  //hard
       "platform":"woocommerce",  //hard
       "register":"no"  //hard
     }



      this._signup.registerUser(data).subscribe({
        next: (response) => {
         console.log(response)
        },
        error: (error) => {
          console.log(error)
        }
      });
    }
    initForm() {

        

      let personalInfo = sessionStorage.getItem('personal-Info')
      let businessInfo = sessionStorage.getItem('business-Info')

      if(personalInfo !== null){

        personalInfo = JSON.parse(personalInfo)
        this._signup.personalInfo = personalInfo
        this._signup.accountVerified = true
      }
      if(businessInfo !== null){
        businessInfo = JSON.parse(businessInfo)
        this._signup.businessInfo = businessInfo
      }

      this.editform = this._fb.group({
          firstName: [this._signup.personalInfo.firstName, [Validators.required,Validators.pattern(/^[A-Za-z\s]+$/)]],
          lastName: [this._signup.personalInfo.lastName, [Validators.required,Validators.pattern(/^[A-Za-z\s]+$/)]],
          email: [
              {
                  value: this._signup.personalInfo?.email,
                  disabled: this._signup.isViewOnly,
              },
              [Validators.required, this.emailFormatValidator()],
          ],
          confirmEmail: [this._signup.personalInfo.confirmEmail, [Validators.required, this.confirmEmailValidator()]],
          phone: [this.formatPhoneNumber(this._signup.personalInfo.phone),[Validators.required,Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
          businessName: [
              this._signup.businessInfo.businessName,
              Validators.required,
          ],
          password: [
              this._signup.personalInfo.password,
              [Validators.required, this.passwordStrengthValidator()],
          ],
      });

      this.route.queryParams
      .subscribe(params => {
            console.log(params)
          this.hasSelectedPlan = params.hasOwnProperty('selectedplan');
          let isFirstTime =  (sessionStorage.getItem('url_plan_selected') === undefined ||
          sessionStorage.getItem('url_plan_selected') === null) ? true : false

          if (this.hasSelectedPlan && isFirstTime) {

                // grab its value
                this.selectedPlanUrl = params['selectedplan'];
                sessionStorage.setItem('url_plan_selected', "1");
                sessionStorage.setItem('selected_plan_id', this.selectedPlanUrl.toString());

                sessionStorage.setItem('url_plan_interval',"m");
                if(params.hasOwnProperty('interval')){
                    sessionStorage.setItem('url_plan_interval', params['interval']);
                }



          }
      });

    }

    emailFormatValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) return null;

        const pvalid = value.match(this.emailValidatorString)
        return pvalid ? null : { emailStrength: true };
        }
    }
    confirmEmailValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
          if (!this.editform) return null;

          const emailControl = this.editform.get('email')?.value.trim();
          const confirmEmailValue = control.value.trim();

          if (!confirmEmailValue || !emailControl) {
              return null;
          }

          return confirmEmailValue === emailControl ? null : { mismatchEmail: true };
      };
  }


    passwordStrengthValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) return null;

        let errors: ValidationErrors = {};

        if (value.length < 8 || value.length > 16) {
          errors['length'] = 'Password must be between 8-16 characters';
        }
        if (!/[A-Z]/.test(value)) {
          errors['uppercase'] = 'At least one uppercase letter required';
        }
        if (!/[a-z]/.test(value)) {
          errors['lowercase'] = 'At least one lowercase letter required';
        }
        if (!/\d/.test(value)) {
          errors['digit'] = 'At least one digit required';
        }
        if (!/[^a-zA-Z0-9]/.test(value)) {
          errors['specialCharacter'] = 'At least one special character required';
        }
        if (/\s/.test(value)) {
          errors['whitespace'] = 'No spaces allowed';
        }

        return Object.keys(errors).length > 0 ? errors : null;
      };
    }

    confirmPasswordStrengthValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        try {
            const value11 = this.editform.get('password').value
        } catch { return null }
        const value1 = this.editform.get('password').value
        if (!value) return null;

        return value === value1 ? null : { conpasswordStrength: true }
        }
    }

    cancel(){
        if(this._signup.accountVerified){
            const confirmed = confirm('Are you sure you want to leave signup this will log you out?');
            if (confirmed) {
                localStorage.removeItem('user-Verified')
                localStorage.removeItem('user')
                sessionStorage.clear()
                window.location.href = 'https://lincsell.com/';
            }
        }
        else{
            window.location.href = 'https://lincsell.com/';
        }
    }

    showTerms() {
       window.open('https://lincsell.com/terms-of-service/','_blank')
      // this.displayTerms = true
        // this.displayWhat = 'terms-and-conditions'
        // this.displayWhos = 'connect-360'
    }

    showEndUserAggreement() {
      window.open('https://lincsell.com/privacy-policy/','_blank')

      // this.displayTerms = true
        // this.displayWhat = 'end-user-agreement'
        // this.displayWhos = 'connect-360'

    }

    formatPhoneNumber(value: string): string {
      const cleaned = value.replace(/\D/g, '');

      if (cleaned.length !== 10) {
        return value;
      }

      return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6, 10)}`;
    }

    async saveFn() {


        if(!this._signup.accountVerified){
            if (!this.isFormValidFn()) return
        }

        if(!this._signup.accountVerified){
            const [isUserValid, isCompanyValid] = await Promise.all([
                this.checkForDuplicateUser(),
                this.doesCompanyExist()
            ]);
            if (!isUserValid || !isCompanyValid) {
                this._spinner.hide();
                return;
            };
        }

        //const what = this.isFormValidFn()
       // if(what){
            this._signup.personalInfo.phone = this.editform.get('phone').value.replace(/\D/g, '')
            this._signup.personalInfo.email = this._signup.personalInfo.email.trim();
            this._signup.personalInfo.confirmEmail = this._signup.personalInfo.email;
            this._signup.personalInfo.password = this._signup.personalInfo.password.trim();
            this._signup.personalInfo.confirmPassword = this._signup.personalInfo.password.trim();

            this._signup.saveBusinessUserV3(this._signup.personalInfo).subscribe(res => {
                if (res.success) {
                    this._signup.personalInfo.userID = res.data
                    sessionStorage.setItem('personal-Info', JSON.stringify(this._signup.personalInfo))
                    this.saveBusinessInformation();

                }
            })
        //}
        // else{
        //   this._spinner.hide()
        //   this._connMessageService.showToastMessage(`Unable to save personal information!`, 'error');
        // }


    }
        saveBusinessInformation(){
            this._signup.businessInfo.userID = this._signup.personalInfo.userID

            this._signup.businessInfo.email = this._signup.personalInfo.email
            this._signup.businessInfo.phone = this._signup.personalInfo.phone
            this._signup.businessInfo.industry = this._signup.businessInfo.industryTypeId;
            if (this._signup.userAccountPendingForPayment) {
                this._signup.businessInfo.businessName = this._globals.userInfo.businessSetup[0].businessDisplayName || this.editform.get('businessName').value.trim()
            }
            else{
                this._signup.businessInfo.businessName = this.editform.get('businessName').value.trim()
            }

            this._signup.saveBusinessInfoV2(this._signup.businessInfo).subscribe(res => {
                if (res.success) {
                    this._signup.businessInfo.businessId = res.data
                    const obj = {
                      BusinessId: this._signup.businessInfo.businessId,
                      UserId: this._signup.personalInfo.userID,
                   };
                     sessionStorage.setItem('business-Info', JSON.stringify(this._signup.businessInfo))
                     this._signup.autoVerify(obj).subscribe((res) => {
                      sessionStorage.setItem('is-Redirect', 'Yes')
                      sessionStorage.setItem('requiredInfo',  JSON.stringify(obj))

                      this.syncUserToWebsite()
                      this._signup.accountVerified = true
                      localStorage.setItem('user-Verified','Yes')
                      this._router.navigate(["signup/check-out"])
                       this._spinner.hide()
                  });

                } else {
                    this._spinner.hide()
                    this._connMessageService.showToastMessage(`Unable to save user's business information!`, 'error');
                }
            }, error => {
                this._spinner.hide()
                this._connMessageService.showToastMessage(`Unable to save user's business information!`, 'error');
            })
        }

  //   doesCompanyExist() {
  //     if (!this.editform.get('businessName').value) return true
  //     const name = this.editform.get('businessName').value.trim()
  //     this.companyNameExist = true
  //     try {
  //     this._spinner.show()
  //     this._signup.doesCompanyExist(name).subscribe(res => {

  //         if (res.success && res.data) {
  //         // this._connMessageService.showToastMessage('Company name already taken, please choose another name!', 'error')
  //         this.editform.controls['businessName'].setErrors({ 'companyexist': true })
  //         this._spinner.hide()
  //         this.companyNameExist = true
  //         } else if (res.success && !res.data) {
  //         this._spinner.hide()
  //         this.companyNameExist = false
  //         }
  //     })
  //     } catch {
  //     this._spinner.hide()
  //     this.companyNameExist = true
  //     }
  // }
  moveCursorToStart(inputElement: any) {
    setTimeout(() => {
          const el = inputElement?.el?.nativeElement?.querySelector('input');

        if (el && (!el.value || el.value.replace(/\D/g, '').length === 0)) {
            el.setSelectionRange(0, 0);
            el.focus();}

    },20);
}
  isFormValidFn() {

    Object.keys(this.editform.controls).forEach(field => {
      const control = this.editform.get(field);
      control?.markAsTouched();
      control?.updateValueAndValidity();
  });

  if(this.editform.valid)return true
  return false

  }

  //  checkForDuplicateUser() {
  //   const value = this.editform.get('email').value.trim()
  //   if (value.length < 3 || !this._globals.isValidEmail(value)) {
  //     this._connMessageService.showToastMessage(`Invalid email format!`, 'error');
  //     return false
  //   }

  //   this._spinner.show()
  //    this._signup.isUserExist(value).subscribe(res => {
  //     if (res.success) {
  //       if (res.data) {
  //         this._spinner.hide()
  //         this._signup.personalInfo.userExist = true
  //         this.editform.controls['email'].setErrors({ 'userexist': true })
  //         //this._connMessageService.showToastMessage(`User Name ${value} already taken, please choose another email`, 'error');
  //       } else {
  //         this._signup.personalInfo.userExist = false
  //       }
  //     }
  //   })
  // }
  async doesCompanyExist(): Promise<boolean> {
    const businessName = this.editform.get('businessName')?.value?.trim();

    if (!businessName) return true; // If no business name, assume valid

    this.companyNameExist = true;
    try {
        // Await the API response and type it explicitly
        const res: any = await lastValueFrom(this._signup.doesCompanyExist(businessName));

        if (res?.success && res?.data) {
            this.editform.controls['businessName'].setErrors({ 'companyexist': true });
            // this._connMessageService.showToastMessage(`Business Name ${businessName} already taken, please choose another business name`, 'error');
            this.companyNameExist = true;
            return false;
        } else {
            this.companyNameExist = false;
            return true;
        }
    } catch (error) {
        console.error('Error checking company existence:', error);
        this.companyNameExist = true; // Assume exists in case of error
        return false;
    }
}
async checkForDuplicateUser(): Promise<boolean> {
    const value = this.editform.get('email').value.trim();

    if (value.length < 3 || !this._globals.isValidEmail(value)) {
      this.editform.controls['email'].setErrors({ 'emailStrength': true });
      // this.editform.controls['email'].setErrors({ 'userexist': true });
        // this._connMessageService.showToastMessage(`Invalid email format!`, 'error');
        return false;
    }

    this._spinner.show();
    try {
        const res:any = await lastValueFrom(this._signup.isUserExist(value));

        if (res.success && res.data) {
            this._signup.personalInfo.userExist = true;
            this.editform.controls['email'].setErrors({ 'userexist': true });
            // this._connMessageService.showToastMessage(`User Name ${value} already taken, please choose another email`, 'error');
            return false;
        } else {
            this._signup.personalInfo.userExist = false;
            return true;
        }
    } catch (error) {
        console.error('Error checking user existence', error);
        this._connMessageService.showToastMessage(`Error checking user existence`, 'error');
        return false;
    }
}
    redirect(){
        if(!this._signup.accountVerified) return false;
        this._router.navigate(['signup/check-out'])
    }

    logout() {

        const confirmed = confirm('Are you sure you want to log out?');
        if (confirmed) {
            localStorage.removeItem('user-Verified')
            localStorage.removeItem('user')
            sessionStorage.clear()
            this._router.navigate(['pages/signin'])
        }

    }

}
